import utf8 from 'utf8'

export function decodeUTF8(input) {
  // This function finds all occurrences of double-escaped sequences and converts them
  const buffer = input.replace(/\\x([0-9A-Fa-f]{2})/g, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  )

  // Now buffer contains the correct UTF-8 characters but might not be properly encoded
  // Encode it to get the bytes and then decode it properly
  // Note: This step assumes that the intermediate step produces a string that
  //       can be correctly interpreted as UTF-8 bytes, which might not always work.
  return utf8.decode(buffer)
}